export default [
  {
    path: '/cults',
    name: 'Cults',
    component: () =>
      import(/* webpackChunkName: 'cults/index' */ './views/Index.vue')
  },
  {
    path: '/cults/:cult_id/quests',
    name: 'Cult Quests',
    component: () =>
      import(/* webpackChunkName: 'cults/quests' */ './views/Quests.vue')
  },
  {
    path: '/submissions',
    name: 'Submissions',
    component: () =>
      import(/* webpackChunkName: 'cults/submissions' */ './views/Submissions.vue')
  },
  {
    path: '/coupons',
    name: 'Quest Coupons',
    component: () =>
      import(/* webpackChunkName: 'cults/coupons' */ './views/Coupons.vue')
  }
]
